module.exports = __webpack_public_path__ + "static/Pega-Digital-Black-Square@2x-white-c41e0ea58a8260600c77aa785914cd39.png";